import React, { useContext } from 'react';
import { Route, ScrollToTop, Switch } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import { Error } from './pages';
import { getRoutes } from './routes';
import './styles/app.scss';

export const App = () => {
  const { instance } = useContext(AppContext);
  const { currentRouteName, currentRouteComponent } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent);

  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route exact path={routes.availableEvents.path}>
          <routes.availableEvents.component />
        </Route>
        <Route path="/error">
          <Error />
        </Route>
        <Route>
          <Error />
        </Route>
      </Switch>
    </>
  );
};

App.propTypes = {};

App.defaultProps = {};
